import { FormlyFieldConfig } from '@ngx-formly/core';

export function minItemsValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Must not have fewer than ${field.templateOptions['minItems']} items`;
}

export function maxItemsValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Must not have more than ${field.templateOptions['maxItems']} items`;
}

export function minlengthValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Must not be less than ${field.templateOptions.minLength} characters`;
}

export function maxlengthValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Must not be more than ${field.templateOptions.maxLength} characters`;
}

export function minValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Must be greater than or equal to ${field.templateOptions.min}`;
}

export function maxValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Must be less than or equal to ${field.templateOptions.max}`;
}

export function multipleOfValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Must be a multiple of ${field.templateOptions.step}`;
}

export function exclusiveMinimumValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Must be greater than ${field.templateOptions.step}`;
}

export function exclusiveMaximumValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Must be less than ${field.templateOptions.step}`;
}

export function constValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Must be equal to constant "${field.templateOptions['const']}"`;
}

export function patternValidationMessage(err: any, field: FormlyFieldConfig) {
    return `Invalid input. Allowed pattern: ${field.templateOptions.pattern}`;
}
